import { useState } from "react";

import { useEvent } from "~/contexts/providers/events";

import CannotBookPopup from "../cannotBookPopup";
import Event from "../memberEvent";
import styles from "./index.module.scss";

const Agenda = () => {
  const { myEvents } = useEvent();

  const [cannotBookPopup, setCannotBookPopup] = useState(false);

  return (
    <div className={styles.eventsGrid}>
      <CannotBookPopup open={cannotBookPopup} setOpen={setCannotBookPopup} />
      {myEvents
        .sort((a, b) => (new Date(a.dateFrom) < new Date(b.dateFrom) ? -1 : 1))
        .map((event) => {
          return (
            <Event
              event={event}
              key={event.id}
              readonly={false}
              setCannotBookPopup={setCannotBookPopup}
            />
          );
        })}
    </div>
  );
};

export default Agenda;
